<template>
  <BackButton />
  <ProfileCard
    v-show="talent"
    :item="talent"
    :noheader="noheader"
    :on-click-user="handleTalentClick"
    style="margin-top: 24px"
  />
  <div style="margin-bottom: 60px"></div>
  <template v-if="talent.products">
    <h2>利用コスメ</h2>
    <n-input
      v-model:value="keyword"
      round
      placeholder="キーワード"
      @update:value="filterProducts"
      style="margin-bottom: 24px"
    />
    <MasonryWall
      :items="products"
      :ssr-columns="1"
      :column-width="250"
      :gap="16"
    >
      <template #default="{ item }">
        <NCard>
          <h5 style="color: lightgray">
            {{ item.product.sub_category }}
          </h5>
          <h3 style="color: dimgray">{{ item.product.brand }}</h3>
          <h3>
            {{ item.product.name }}
            <span style="color: gray">{{ item.product.variant?.name }}</span>
          </h3>
          <template #cover>
            <div class="image-container">
              <img
                :id="'main-' + item.product.id"
                :src="item.product.image_url"
                class="card-image"
                @mousedown="showVariantImage(item)"
              />
              <img
                :id="'variant-' + item.product.id"
                v-if="item.product.variant?.image_url"
                :src="item.product.variant?.image_url"
                @mousedown="showMainImage(item)"
                class="card-image"
              />
            </div>
          </template>
          <template #action>
            <n-button
              quaternary
              type="info"
              @click="showUsingTalent(item.product.id)"
              >このコスメを利用している人を見る</n-button
            >
          </template>
          <template #footer>
            <n-popconfirm
              :show-icon="false"
              negative-text="いいえ"
              positive-text="はい"
              @positive-click="handlePositiveClick(item.product.url)"
            >
              <template #trigger>
                <small style="color: gray"
                  >出典: {{ item.product.source }}</small
                >
              </template>
              出典元を表示しますか？
            </n-popconfirm>
          </template>
        </NCard>
      </template>
    </MasonryWall>
  </template>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import MasonryWall from '@yeger/vue-masonry-wall'
import ProfileCard from '@/components/ProfileCard.vue'
import BackButton from '@/components/BackButton.vue'
import api from '@/api'

const talent = ref({})
const products = ref([])
const keyword = ref('')
const noheader = ref(false)
const route = useRoute()
const router = useRouter()

const showUsingTalent = (productId) => {
  router.push({ name: 'products', params: { id: productId } })
}

const handlePositiveClick = (url) => {
  window.open(url, '_blank')
}

const handleTalentClick = (item) => {
  router.push({
    name: 'talents',
    params: { account: item.x_account }
  })
}

const fetchData = async () => {
  const response = await api.get(`/talents/${route.params.account}/`)
  talent.value = response.data
  products.value = response.data.products

  // メタタグを更新
  document.title = `${talent.value.name}さんのメイクレシピ | アイドルメイクレシピ`
  document.description = `${talent.value.name}さんのメイクレシピ`
}

onMounted(() => {
  if (window.location.href.includes('noheader=1')) {
    noheader.value = true
  }
  fetchData()
})

function showVariantImage(item) {
  if (!item.product.variant?.image_url) {
    return
  }
  const mainImage = document.getElementById('main-' + item.product.id)
  const variantImage = document.getElementById('variant-' + item.product.id)
  mainImage.style.display = 'none'
  variantImage.style.display = 'block'
}
function showMainImage(item) {
  const mainImage = document.getElementById('main-' + item.product.id)
  const variantImage = document.getElementById('variant-' + item.product.id)
  mainImage.style.display = 'block'
  variantImage.style.display = 'none'
}

function filterProducts() {
  if (keyword.value === '') {
    products.value = talent.value.products
  } else {
    products.value = talent.value.products.filter((product) => {
      return (
        product.product.name
          .toLowerCase()
          .includes(keyword.value.toLowerCase()) ||
        product.product.brand
          .toLowerCase()
          .includes(keyword.value.toLowerCase()) ||
        product.product.variant?.name
          .toLowerCase()
          .includes(keyword.value.toLowerCase())
      )
    })
  }
}
</script>

<style scoped>
.image-container {
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
}
.card-image {
  width: 100%;
  height: 100%;
  scale: 0.8;
  object-fit: cover;
  object-position: center;
}
.card-image {
  transition: transform 0.3s ease;
}
.card-image:hover {
  transform: scale(1.1);
}
</style>
